"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var context_1 = require("../context");
var computeAttr = function (propAttr, layoutAttr, defaultValue) {
    if (typeof propAttr !== 'undefined')
        return propAttr;
    if (typeof layoutAttr !== 'undefined')
        return layoutAttr;
    return defaultValue;
};
exports.useLayout = function (props) {
    var isLayout = props.isLayout || false;
    var defaultSettings = props.defaultSettings || {};
    var context = react_1.useContext(context_1.LayoutContext);
    var enableLayout = Object.keys(context).length > 0;
    var isRoot = isLayout && !enableLayout;
    var autoRow = computeAttr(props.autoRow, context.autoRow, false);
    var flex = computeAttr(props.flex, context.flex, false);
    var columns = computeAttr(props.columns, context.columns, 3);
    var responsive = (props.responsive || context.contextResponsive) && {
        lg: computeAttr((props.responsive || {}).lg, (context.contextResponsive || {}).lg, columns),
        m: computeAttr((props.responsive || {}).m, (context.contextResponsive || {}).m, columns),
        s: computeAttr((props.responsive || {}).s, (context.contextResponsive || {}).s, columns)
    };
    var contextResponsive = responsive ? responsive : context.contextResponsive;
    var size = computeAttr(props.size, context.size, undefined);
    var gutter = computeAttr(props.gutter, context.gutter, defaultSettings.gutter || 0);
    var hasBorder = computeAttr(props.hasBorder, context.hasBorder, true);
    var inset = computeAttr(props.inset, context.inset, false);
    var full = computeAttr(props.full, context.full, false);
    var labelAlign = computeAttr(props.labelAlign, context.labelAlign, 'right');
    var labelWidth = computeAttr(props.labelWidth, context.labelWidth, -1);
    var wrapperWidth = computeAttr(props.wrapperWidth, context.wrapperWidth, -1);
    var enableSafeWidth = computeAttr(props.enableSafeWidth, context.enableSafeWidth, true);
    var labelCol = computeAttr(props.labelCol, context.labelCol, -1);
    var wrapperCol = computeAttr(props.wrapperCol, context.wrapperCol, -1);
    var span = computeAttr(props.span, 1, 1);
    var grid = computeAttr(props.grid, context.grid, false);
    var inline = computeAttr(props.inline, context.inline, false);
    if (grid && inline) {
        if (props.grid) {
            inline = false;
            grid = true;
        }
        if (props.inline) {
            grid = false;
            inline = true;
        }
    }
    if (inline && !isLayout) {
        labelCol = -1;
        wrapperCol = -1;
    }
    return {
        enableLayout: enableLayout,
        isRoot: isRoot,
        isLayout: isLayout,
        grid: grid,
        inline: inline,
        autoRow: autoRow,
        flex: flex,
        inset: inset,
        hasBorder: hasBorder,
        columns: columns,
        contextColumns: context.columns,
        full: full,
        labelWidth: labelWidth,
        wrapperWidth: wrapperWidth,
        labelCol: labelCol,
        wrapperCol: wrapperCol,
        labelAlign: labelAlign,
        gutter: gutter,
        span: span,
        context: context,
        responsive: responsive,
        contextResponsive: contextResponsive,
        enableSafeWidth: enableSafeWidth,
        size: size,
    };
};
exports.useLayoutItem = function (props) {
    var layout = exports.useLayout(props);
    var enableLayout = layout.enableLayout;
    return enableLayout ? layout : null;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/hooks/useLayout.js
// module id = 2076
// module chunks = 0